export const convertFeetToCm = height => {
  let heightSplit = height.split(".");
  let feet = heightSplit[0] !== '' ? parseInt(heightSplit[0]) * 30.48 : 0;
  let inches = heightSplit[1] !== '' ? parseInt(heightSplit[1]) * 2.54 : 0;
  return Math.round(feet+inches);
}

export const convertCmToFeet = height => {
  let inches = Math.round (height / 2.54);
  let feet = Math.floor(inches / 12);
  inches = inches % 12;
  return feet+'.'+inches;
}

export const convertLbsToKgs = weight => Math.round( weight / 2.2046);

export const convertKgsToLbs = weight => Math.round(weight * 2.2046);

export const calculateBMI = (weight, weightUnit, height, heightUnit) => {
  let weightB, heightB;
  if(weightUnit === 'kg') {
    weightB = weight;
  }else {
    weightB = convertLbsToKgs(weight);
  }

  if(heightUnit === 'cm') {
    heightB = height/100;
  }else {
    let cm = convertFeetToCm(height);
    heightB = cm/100;
  }
  return ((heightB > 0 && weightB > 0) ? (weightB / (heightB * heightB)).toFixed(1) : 0);
}

export const weightOptions = [{
  label: "lbs",
  value: "lbs"
},{
  label: "kg",
  value: "kg"
}];

export const heightOptions = [{
  label: "ft",
  value: "ft"
},{
  label: "cm",
  value: "cm"
}];